import { ActionMenuLink, stenaPen } from '@stenajs-webui/elements';
import type { FC } from 'react';
import { routeCreators } from '../../../../../common/routes/AppRoutes';

interface ActionMenuClaimsLinkProps {
  bookingNo: number;
  disabled?: boolean;
  onClick: () => void;
}

export const ActionMenuClaimsLink: FC<ActionMenuClaimsLinkProps> = ({
  bookingNo,
  disabled,
  onClick,
}) => {
  return (
    <ActionMenuLink
      target="_blank"
      href={routeCreators.bookingClaims({ bookingNo })}
      disabled={disabled}
      onClick={onClick}
      leftIcon={stenaPen}
      label={'Make claim'}
    />
  );
};
